module.exports = __webpack_public_path__ + "d4bf7b488530ad738c2a9b7602574f99.pdf";